import React from 'react';
import { useMessage } from './useMessage';
import { IFile } from '../types/file';

export interface IFileActionButtonProps {
  fileId?: string | undefined | null;
  filePath?: string | undefined | null;
  modelInstanceId?: string | undefined | null;
  file?: IFile | undefined | null;
  label?: string;
  icon?: React.ReactNode | null;
  type?: 'link' | 'primary' | 'text' | 'default' | 'dashed' | undefined;
  variant?:
    | 'link'
    | 'text'
    | 'dashed'
    | 'outlined'
    | 'solid'
    | 'filled'
    | undefined;
  size?: 'small' | 'middle' | 'large' | undefined;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  visible?: boolean;
}

interface IUseFileActionParams {
  fileId: string | undefined | null;
  filePath: string | undefined | null;
  modelInstanceId: string | undefined | null;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  isLoadingCore: boolean;
  isLoadingInteract: boolean;
  onCoreAction: (params: { fileId: string; modelInstanceId: string }) => void;
  onInteractAction: (params: { fileId: string }) => void;
}

export const useFileAction = ({
  fileId,
  filePath,
  modelInstanceId,
  onClick,
  disabled,
  loading,
  isLoadingCore,
  isLoadingInteract,
  onCoreAction,
  onInteractAction,
}: IUseFileActionParams) => {
  const message = useMessage();

  const isLoading = loading || isLoadingCore || isLoadingInteract;
  const isDisabled = disabled || isLoading || !fileId;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (onClick) {
      onClick(e);
      return;
    }

    if (!fileId || !filePath) {
      message.error('File not found');
      return;
    }

    if (filePath.includes('uploads/interact')) {
      onInteractAction({ fileId });
      return;
    }

    if (filePath.includes('model-instances') && modelInstanceId) {
      onCoreAction({ fileId, modelInstanceId });
      return;
    }

    message.error('File not found');
  };

  return { isLoading, isDisabled, handleClick };
};
